const UUID_REGEX = new RegExp(
  '^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$',
  'i',
)

// eslint-disable-next-line import/prefer-default-export
export function isUUID(value) {
  return UUID_REGEX.exec(value)
}
